var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKotlininline = function SvgKotlininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kotlin_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin_inline_svg__b)",
    d: "M16 16H0V0h16L8 7.997z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kotlin_inline_svg__b",
    x1: 1599.85,
    x2: 0.159,
    y1: -0.172,
    y2: 1600.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#E44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#C711E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F52FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kotlin_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgKotlininline;